import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useCurrency, Currency } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<Currency>
    useData={useCurrency}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
